/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const overviewQueryInputDataSortSchema = z.enum([
	'created_at',
	'name',
	'candidates',
	'hires',
	'cost_per_candidate',
])

export type OverviewQueryInputDataSortSchema = z.infer<typeof overviewQueryInputDataSortSchema>
